import {
  Pipe, PipeTransform,
} from '@angular/core'
import {
  Duration, DurationUnit,
} from 'luxon'

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  public transform(
    duration: string | number,
    unit: DurationUnit = 'seconds',
  ): Duration {
    return Duration.fromObject({
      [unit]: duration,
    })
  }
}
